import { CWComponents } from "@channelwill/components"
import { useEffect } from "react"

import stores from "@/stores"
import { getShopifyIdToken } from "@/utils/shopifySessionToken"

export const CWComponentsProvider = () => {
  const { userInfoSore, commonStore } = stores

  // 商家地址&商家的语种
  const lang = commonStore.currentLanguageCode
  const storeName = window.shopify ? window.shopify.config.shop : userInfoSore.data?.store_name

  useEffect(() => {
    if (!lang || !storeName) return
    CWComponents.init({
      baseUrl: import.meta.env.VITE_MID_API,
      // 引入组件的相关映射:
      // { 业务分类 :{' 组件唯一key值 '}}
      componentMaps: {
        "recommendations": ["home_recommend_solution"],
      },
      appId: "518111167165628416",
      lang,
      shopifyDomain: storeName,
    })

    // 注册 Shopify Session Token getter：授权组件（SupportAccess）的接口靠它注入鉴权头
    CWComponents.setShopifyIdToken(getShopifyIdToken)
  }, [storeName, lang])
  return (
    <></>
  )
}
